<template>
  <div class="container">
    <h1 class="title">Preguntas Frecuentes</h1>
    <details>
      <summary @click="toggleAccordion" class="text-body"><b>¿Cómo envío una solicitud de candidato?</b></summary>
      <p class="text-body">Cumplimentando nuestro formulario que puedes encontrar  
       <a href="https://ademass-profile-request.netlify.app/" style="color:white;">pulsando aquí.</a> </p>
    </details>

    <details>
      <summary class="text-body"><b>¿Qué tipo de perfiles tenéis?</b></summary>
      <p class="text-body">Todo tipo de perfiles relacionados con la programación:<br>
       Desarrollador FrontEnd, BackEnd, FullStack, Móvil, Videojuegos, DevOps, Ciberseguridad, Machine Learning, Científico de Datos, Blockchain, CMS y Muchos Más..</p>
    </details>
    <details>
      <summary class="text-body"><b>¿Qué ocurre una vez que publique mi oferta?</b></summary>
      <p class="text-body">Queda visible automaticamente a toda la comunidad. Los perfiles interesados se podrán apuntar a la oferta. Podrás seleccionar y comunicarte con ellos a través de tu panel. </p>
    </details>
    <details>
      <summary class="text-body"><b>¿Si no me cobráis nada, cómo monetizais vuestro negocio?</b></summary>
      <p class="text-body">Nuestro modelo de formación avanzada por suscripción nos permite no cobrar nada a las empresas y facilitar así la inserción laboral de nuestros alumnos. </p>
    </details>
  </div>
</template>

<script   setup>
import { ref } from 'vue';

const isOpen = ref(false);

const toggleAccordion = () => {
  isOpen.value = !isOpen.value;
};
</script>

<style scoped>
   .text-body{
      color: rgba(35, 35, 35, 1);
      font-size: 20px;
      font-style: Medium;
      font-family: Darker Grotesque;
      font-weight: 500;
    }
  .title {
          color: rgba(39, 52, 68, 1);
          font-size: 60px;
          font-style: Black;
          text-align: center;
          font-family: Darker Grotesque;
          font-weight: 900;
        }


.container {
  margin-top: 0;
  margin-left: 18%;
  margin-right: 18%;
  position: relative;
  margin-top: 100px;
}

.container::before {
  content: "";
  position: absolute;
  top: 0;
  right: 0;
  /* Ajuste para ubicar el gradiente en el lado derecho */
  width: 60%;
  height: 100%;
  background: linear-gradient(to left, transparent 0%, #F9FAE9 0%, #F9FAE9 100%);
  z-index: -1;
}

details {
  background-color: white;
  padding: 10px;
  border: none;
  border-radius: 5px;
  margin-bottom: 5px;
  box-shadow: 2px 2px 2px rgba(0, 0, 0, 0.3);
  margin-bottom: 15px;
  margin-right: 10px;
}


summary {
  border-radius: 5px;
  padding: 10px;
  background-color: white;
  cursor: pointer;
}

details[open] {
  background-color: #2ea3f2;
}
details[open] summary {
  background-color: #2ea3f2;
  color: white;
  padding: 10px;
}

details p {
  transition: background-color 0.3s ease;
}

details[open] p {
  background-color: #2ea3f2;
  color: white;
  padding: 8px;
  margin-top: 10px;
}

p {
  margin-top: 10px;
  padding: 8px;
  color: white;
  background-color: #2ea3f2;
}
@media screen and (max-width: 600px){
  .title{
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .container{
    width: 85%;
  margin-left: 5%;
  margin-right: 5%;
  
  }
}
</style>